import { ThemeUICSSObject } from '@apia/theme';

export const formStyles: ThemeUICSSObject = {
  '.fieldWrapper': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',

    '&.checkbox': {
      alignItems: 'center',
    },
  },

  '.error': {
    borderLeftStyle: 'solid',
    borderLeftWidth: '4px',
    borderLeftColor: 'danger',
  },
  '.touched': {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'orange',
  },
};
